"use client";

import { useEffect, useRef } from "react";

export function SpotlightCursor() {
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) {
      return;
    }
    const el = divRef.current;
    if (!el) return;
    const safeEl = el;

    // Start off-screen
    let x = -1000, y = -1000;
    let tx = -1000, ty = -1000;
    let rafId: number;

    function onMove(e: MouseEvent) {
      tx = e.clientX;
      ty = e.clientY;
    }

    function tick() {
      // Smooth follow via lerp
      x += (tx - x) * 0.09;
      y += (ty - y) * 0.09;
      safeEl.style.background =
        `radial-gradient(650px circle at ${x}px ${y}px, rgba(232,197,71,0.055) 0%, rgba(232,197,71,0.015) 35%, transparent 70%)`;
      rafId = requestAnimationFrame(tick);
    }

    window.addEventListener("mousemove", onMove);
    rafId = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <div
      ref={divRef}
      className="pointer-events-none fixed inset-0"
      style={{ zIndex: 9999 }}
      aria-hidden
    />
  );
}
